import { render, staticRenderFns } from "./SponsoredAdBanner.vue?vue&type=template&id=4edd9a5c&scoped=true&"
import script from "./SponsoredAdBanner.vue?vue&type=script&lang=js&"
export * from "./SponsoredAdBanner.vue?vue&type=script&lang=js&"
import style0 from "./SponsoredAdBanner.vue?vue&type=style&index=0&id=4edd9a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd9a5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VIcon,VImg})
